import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Pagination,
  CircularProgress,
} from "@mui/material";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import CustomText, { textStyles } from "../../../components/CustomText";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { BASE_URL } from "../../../components/BaseUrl";
import { decryptToken } from "../../../Utlis/Encryption";
import CustomButton from "../../../components/CustomButton";
import empty from "../../../assets/empty.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { getLocalizedNotification } from "../../../utils/notificationLocale";
import { apiFetch } from "../../../utils/apiService";
const Notifications = () => {
  const { t, i18n } = useTranslation("");
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
const navigate=useNavigate();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const limit = 5;
  const [buttonLoading, setButtonLoading] = useState(false); // For button loader

  // ------------------- Fetch Notifications -------------------
//   const fetchNotifications = async (pageNum = 1) => {
//     setLoading(true);
//     try {
//       const offset = (pageNum - 1) * limit;
//       const response = await fetch(
//         `${BASE_URL}/notifications/company-admin?limit=${limit}&offset=${offset}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${decryptedToken}`,
//           },
//         }
//       );

//       if (!response.ok) throw new Error("Failed to fetch notifications");
//       const data = await response.json();

//    if (data.error) {
//   console.error("Error fetching notifications:", data.message);
//   setNotifications([]);  // Empty the notifications if there's an error
// } else {
//   const { notifications, pagination } = data.data;
//   setNotifications(notifications);  // Properly set notifications
//   setTotalPages(pagination.pages);
// }
//     } catch (error) {
//       console.error("Error fetching notifications:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
const fetchNotifications = async (pageNum = 1) => {
  setLoading(true);
  try {
    const response = await fetch(
      `${BASE_URL}/notifications/company-admin?page=${pageNum}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );

    if (!response.ok) throw new Error("Failed to fetch notifications");

    const data = await response.json();

    if (data.error) {
      setNotifications([]);
      console.error("Error:", data.message);
    } else {
      setNotifications(data.data.notifications);
      setTotalPages(data.data.pagination.pages);
    }
  } catch (err) {
    console.error("❌ Fetch error:", err);
  } finally {
    setLoading(false);
  }
};

  // ------------------- Mark All As Read -------------------

  const markAllAsRead = async () => {
    setButtonLoading(true); // Show loading spinner on button click

    try {
      const data = await apiFetch(
        `${BASE_URL}/notifications/company-admin/mark-all-read`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      if (data.ok && !data.error) {
        // Success toast (already localized to the current language by apiFetch)
        toast.success(data.message);
        fetchNotifications(page); // Re-fetch notifications after marking as read
      } else {
        // Error toast
        toast.error(data.message || t("error.markReadFailed"));
      }
    } catch (error) {
      console.error("Error marking all as read:", error);
      toast.error(t("error.markReadFailed")); // Show error toast in selected language
    } finally {
      setButtonLoading(false); // Hide loading spinner after API call finishes
    }
  };


  useEffect(() => {
    fetchNotifications(page);
  }, [page]);


const handleNotificationClick = (notification) => {
  const state = { fromDashboard: true };

  switch (notification.type) {
    case "worker_registration":
      navigate("/all-employees", { state });
      break;

    case "birthday":
      navigate("/all-employees", { state });
      break;

    case "new_message":
      navigate("/messages", { state });
      break;

    case "attendance_validation_failure":
      navigate("/unvalidated-punches", { state });
      break;

    case "new_request":
      navigate("/request-management", { state });
      break;

    default:
      navigate("/notifications", { state });
      break;
  }
};


  // ------------------- UI -------------------
  return (
    <Box sx={{ px: 2, mt: 1 }}>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "white",
          border: "2px solid #091E4224",
          borderRadius: 2,
          py: 2,
          minHeight: "70vh",
          position: "relative",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E0E0E0",
            px: 2,
            pb: 2,
            mb: 2,
            
          }}
        >
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 600,
              fontSize: "18px",
              color: "#003149",
            }}
          >
            {t("notification_screen.title") || "Notifications"}
          </CustomText>

          {/* <IconButton
            onClick={markAllAsRead}
            sx={{
              backgroundColor: "#006EC2",
              color: "white",
              px: 2,
              borderRadius: "6px",
              fontSize: 14,
                    fontFamily: 'Poppins, sans-serif',

              "&:hover": { backgroundColor: "#005bb5" },
            }}
          >
            <MarkEmailReadOutlinedIcon fontSize="small" sx={{ mr: 0.5 }} />
            {t("markAsRead")}
          </IconButton> */}
              <IconButton
            onClick={markAllAsRead} // Trigger mark all as read
            sx={{
              backgroundColor: "#006EC2",
              color: "white",
              px: 2,
              borderRadius: "6px",
              fontSize: 14,
              fontFamily: "Poppins, sans-serif",
              "&:hover": { backgroundColor: "#005bb5" },
            }}
            disabled={buttonLoading} // Disable button while loading
          >
            {buttonLoading ? (
              <CircularProgress size={20} sx={{ color: "blue" }} /> // Show loader
            ) : (
              <>
                <MarkEmailReadOutlinedIcon fontSize="small" sx={{ mr: 0.5 }} />
                {t("markAsRead")} {/* Show the text when not loading */}
              </>
            )}
          </IconButton>
        </Box>

        {/* Loader */}
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "50vh",
            }}
          >
            <CircularProgress size={40} />
          </Box>
        ) : notifications.length === 0 ? (
                  <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 5,
              }}
            >
              <img
                src={empty}
                alt="No Data"
                style={{ width: 200, marginBottom: 16 }}
              />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#003149",
                }}
              >
                {t("empty.no_user")}
              </CustomText>
            </Box>
        ) : (
          <>
            {/* Notification Table */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                px: 2,
              }}
            >
              {notifications.map((n, i) => {
                const { title, message } = getLocalizedNotification(n, i18n.language);
                return (
                <Box
                  key={i}
                   onClick={() => handleNotificationClick(n)}
                  sx={{
                        cursor: "pointer",

                     backgroundColor: !n.is_read ? "#EAF4FF" : "#fff",
    border: `2px solid ${!n.is_read ? "#006EC2" : "#DADADA"}`, 
                    borderRadius: 2,
                    px: 2,
                    py: 1.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        color: "#212121",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#555",
                        mt: 0.5,
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {message}
                    </Typography>
                  </Box>

                  {/* <Typography
                    sx={{
                      fontSize: 12,
                      color: "#5A6474",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  >
                    {new Date(n.sent_at).toLocaleString()}
                  </Typography> */}
                  
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#5A6474",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  >
                    {new Date(n.sent_at).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </Typography>
                </Box>
                );
              })}
            </Box>

            {/* Pagination */}
            {totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={(e, val) => setPage(val)}
                   color="primary"
    shape="rounded"
                />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default Notifications;
